import {connect, IConnectProps} from 'globx-react';
import * as React               from 'react';
import {Subject}                from 'rxjs';

import StoreName              from '../../../../State/Shared/Constants/StoreName';
import Playback               from '../../../../State/Stores/Playback/Playback';
import * as TestIds           from '../../../Shared/Constants/TestIds';
import UiEventType            from '../../../Shared/Constants/UiEventType';
import IUiEventsStreamPayload from '../../../Shared/Interfaces/IUiEventsStreamPayload';
import composeTokenList       from '../../Util/composeTokenList';
import renderTestId           from '../../Util/renderTestId';

import * as styles from '../PlaybackButtons/playbackButtons.css';

import IconFastForward from './Assets/IconFastForward';

interface IFastForwardProps extends IConnectProps<Playback> {
    areControlsIdle: boolean;
    uiEvents$: Subject<IUiEventsStreamPayload>;
}

@connect(StoreName.PLAYBACK)
class FastForward extends React.Component<IFastForwardProps> {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    public shouldComponentUpdate(nextProps: IFastForwardProps): boolean {
        return (
            nextProps.value.isAtVideoEdge !== this.props.value.isAtVideoEdge ||
            nextProps.areControlsIdle !== this.props.areControlsIdle
        );
    }

    public render(): JSX.Element {
        const testId = composeTokenList([
            TestIds.PLAYER_BUTTON_FAST_FORWARD,
            [!this.props.areControlsIdle && !this.props.value.isAtVideoEdge, TestIds.PLAYER_BUTTON_FAST_FORWARD_VISIBLE]
        ]);

        return (
            <button
                className={styles.playbackButton}
                onClick={this.handleClick}
                disabled={this.props.value.isAtVideoEdge}
                data-test-id={renderTestId(testId)}
            >
                <IconFastForward/>
            </button>
        );
    }

    private handleClick(): void {
        this.props.uiEvents$.next({
            type: UiEventType.FAST_FORWARD_TAP
        });
    }
}

export default FastForward;